import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { Sidebar as SidebarShell, SidebarProvider } from "@/components/_atoms/sidebar";
import { useRightAsideStore } from "@/stores/right-aside-store";

import { useLayout } from "../use-layout";

import { RIGHT_ASIDE_WIDTH } from "./right-aside-width";

interface SheetProps extends PropsWithChildren {
  reserveSpace?: boolean;
}

export const Sheet: FC<SheetProps> = ({ children, reserveSpace = true }) => {
  const { t } = useTranslation("common");
  const { isHidden, setIsHidden } = useRightAsideStore();
  const { offsetTop } = useLayout();

  return (
    <SidebarProvider
      open={!isHidden}
      onOpenChange={(open) => setIsHidden(!open)}
      className="min-h-0 w-auto"
      style={{ "--sidebar-width": `${RIGHT_ASIDE_WIDTH}px` } as React.CSSProperties}
    >
      <SidebarShell
        side="right"
        collapsible="offcanvas"
        reserveSpace={reserveSpace}
        style={{ paddingTop: `${offsetTop}px` }}
        aria-label={t("sidebar.rightSidebar")}
      >
        <aside
          tabIndex={0}
          aria-label={t("sidebar.rightSidebar")}
          className="flex h-full w-full flex-col overflow-hidden bg-background focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus"
        >
          {children}
        </aside>
      </SidebarShell>
    </SidebarProvider>
  );
};
